import Endpoint from '../Endpoint'

export default class Klarna extends Endpoint {
  async push(orderId) {
    return this.client.request({
      method: 'POST',
      endpoint: `/klarna/${orderId}/push`,
    })
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/Klarna.js